<div class="row">
	<div class="col-sm-6">
		<div class="c-form-group">
			<div class="c-form-group__label">
				<label for="margin">Region Margin</label>
			</div>
			<input id="margin" cclFormInput type="text" class="c-form-group__input c-input--required" [(ngModel)]="regionConfig.margin">
			<div class="c-form-group__hint">&nbsp;</div>
		</div>
	</div>
	<div class="col-sm-6">
		<div class="c-form-group">
			<div class="c-form-group__label">
				<label for="padding">Region Padding</label>
			</div>
			<input id="padding" cclFormInput type="text" class="c-form-group__input c-input--required" [(ngModel)]="regionConfig.padding">
			<div class="c-form-group__hint">&nbsp;</div>
		</div>
	</div>
	<div class="col-sm-6">
		<div class="c-form-group">
			<div class="c-form-group__label">
				<label for="background">Background Color</label>
			</div>
			<div class="input-group" [(colorPicker)]="regionConfig.background" [cpAlphaChannel]="'disabled'" [cpOutputFormat]="'hex'">
				<input id="background" cclFormInput type="text" [(ngModel)]="regionConfig.background" class="c-form-group__input form-control">

				<div class="input-group-append">
					<span class="c-color-picker input-group-text" [ngStyle]="{'background-color': regionConfig.background}">&nbsp;</span>
				</div>
			</div>

			<div class="c-form-group__hint">&nbsp;</div>
		</div>
	</div>
	<div class="col-sm-6">
		<div class="c-form-group">
			<div class="c-form-group__label">
				<label for="rounded">Rounded Corners</label>
			</div>
			<input id="rounded" cclFormInput type="text" class="c-form-group__input c-input--required" [(ngModel)]="regionConfig.corner">
			<div class="c-form-group__hint">&nbsp;</div>
		</div>
	</div>
</div>